export const EVENTS = {
  subscribe: "bo:subscribe",
  unsubscribe: "bo:unsubscribe",
  priceTick: "bo:priceTick",
  priceTickLegacy: "bot:priceTick",
  getCurrentRound: "bo:getCurrentRound",
  getMyOpenBids: "bo:getMyOpenBids",
  placeBid: "bo:placeBid",
  roundSnapshot: "bo:roundSnapshot",
  roundStarted: "bo:roundStarted",
  roundLocked: "bo:roundLocked",
  roundSettled: "bo:roundSettled",
  bidAccepted: "bo:bidAccepted",
  bidRejected: "bo:bidRejected",
  roundStatsUpdated: "bo:roundStatsUpdated",
  myBidSettled: "bo:myBidSettled",
};

export const ROUND_VARIANTS = [
  {
    id: "10s",
    label: "10s",
    stakeLabel: "$0.10-$20",
    minimumStake: 0.1,
    maximumStake: 20,
    tradeWindowSeconds: 10,
    lockWindowSeconds: 3,
  },
  {
    id: "20s",
    label: "20s",
    stakeLabel: "$0.10-$20",
    minimumStake: 0.1,
    maximumStake: 20,
    tradeWindowSeconds: 20,
    lockWindowSeconds: 4,
  },
  {
    id: "30s",
    label: "30s",
    stakeLabel: "$0.10-$20",
    minimumStake: 0.1,
    maximumStake: 20,
    tradeWindowSeconds: 30,
    lockWindowSeconds: 5,
  },
  {
    id: "1m",
    label: "1m",
    stakeLabel: "$0.10-$20",
    minimumStake: 0.1,
    maximumStake: 20,
    tradeWindowSeconds: 60,
    lockWindowSeconds: 6,
  },
];

export function getRemainingSeconds(endTime, now) {
  const end = new Date(endTime).getTime();
  const current = now || Date.now();
  const remainingMs = end - current;
  return Math.max(0, Math.floor(remainingMs / 1000));
}

export const QUICK_AMOUNTS = [0.10, 0.25, 0.50];
export const FALLBACK_PLAYERS = [
  "BMNhY",
  "uCfXU",
  "skVJY",
  "tcfEZ",
  "MForj",
  "pR9uT",
  "kJm4Q",
  "Zx1Np",
];
export const HOUSE_EDGE_RATIO = 0.03;
export const SETTLEMENT_PHASE_MS = 1800;
export const PAYOUT_PHASE_MS = 2600;
export const OUTCOME_SLOT_COUNT = 6;
export const PAYOUT_TRANSFER_SHARE = 0.58;
export const RACE_TIMER_LEAD_START_PERCENT = 14;
export const RACE_TIMER_LEAD_END_PERCENT = -12;
export const RACE_FLAG_GAP_PERCENT = 8;
export const LIVE_MARKER_FALLBACK_PERCENT = 64;
export const FLAG_PASS_OVERSHOOT_PERCENT = 1;
export const FLAG_PASS_MAX_WAIT_MS = 1400;
export const ROUND_JOIN_DELAY_MS = 420;
export const ROUND_JOIN_STAGGER_MIN_MS = 95;
export const ROUND_JOIN_STAGGER_MAX_MS = 170;
export const FIXED_PAYOUT_PERCENT = 82;
export const FIXED_PAYOUT_MULTIPLIER = 1.82;
export const DEFAULT_ORDER_DURATION_SECONDS = 10;
export const FINISHED_ORDER_RETENTION_MS = 0;
export const CUSTOM_EXPIRY_ID = "custom";
export const CUSTOM_EXPIRY_MIN_SECONDS = 5;
export const CUSTOM_EXPIRY_MAX_SECONDS = 300;
export const CHART_INTERVALS = ["Tick", "10s", "1m", "5m", "10m", "30m", "1hr"];
export const CHART_INTERVAL_SECONDS = {
  "Tick": 1,
  "10s": 10,
  "1m": 60,
  "5m": 300,
  "10m": 600,
  "30m": 1800,
  "1hr": 3600,
};
export const TEMP_BYPASS_BALANCE_CHECK = true;
export const EXPIRY_OPTIONS = [
  { id: "1m", seconds: 60, label: "1m", value: "1:00" },
  { id: "30s", seconds: 30, label: "30s", value: "0:30" },
  { id: "20s", seconds: 20, label: "20s", value: "0:20" },
  { id: "10s", seconds: 10, label: "10s", value: "0:10" },
];
export const TIME_PICKER_OPTIONS = [
  ...EXPIRY_OPTIONS,
  { id: "2m", seconds: 120, label: "2m", value: "2:00" },
  { id: "3m", seconds: 180, label: "3m", value: "3:00" },
  { id: "5m", seconds: 300, label: "5m", value: "5:00" },
  { id: "10m", seconds: 600, label: "10m", value: "10:00" },
];
export const AMOUNT_PICKER_OPTIONS = [0.10, 0.25, 0.50, 1, 5, 10, 20, 50, 100];
export const orderStickyEndTimes = new Map();

export const rankDisplayMap = {
  basic: "Basic",
  vip: "VIP",
  vvip: "VVIP",
};

